export default __webpack_public_path__ + "static/media/american.3ca015d5.png";